<template>
  <div>
    <!-- 任务完成结果 -->
    <!-- 任务开始时间，任务完成时间 -->
    <!-- 任务流程 -->
    <el-descriptions  :column="3" border>
      <el-descriptions-item>
        <template slot="label">
          客户名称
        </template>
        {{taskInfo.customerName}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          任务类型
        </template>
        {{taskTypeMap[taskInfo.taskType]}}
      </el-descriptions-item>
      <el-descriptions-item>  
        <template slot="label">
          任务状态
        </template>
        {{missionStatusMap[taskInfo.taskStatus]}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          所属期
        </template>
        {{taskInfo.currentPeriod}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          任务创建时间
        </template>
        {{taskInfo.createTime}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          任务结束时间
        </template>
        {{taskInfo.completeTime}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          任务流程
        </template>
        <el-tag size="small" class="c-pointer" @click="openPhotoState">查看完整任务流程截图</el-tag>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          错误原因
        </template>
        {{taskInfo.taskStatusDesc}}
      </el-descriptions-item>
      
    </el-descriptions>
    <el-descriptions v-if="taskInfo.fileList && taskInfo.fileList.length" :column="1" border>
      <el-descriptions-item>
        <template slot="label">
          任务最终片段
        </template>
        <el-image :src="taskInfo.fileList[taskInfo.fileList.length - 1]" :preview-src-list="[taskInfo.fileList[taskInfo.fileList.length - 1]]" style="width: 800px"></el-image>
        <!-- <img style="width:800px" :src="taskInfo.fileList[taskInfo.fileList.length - 1]" alt=""> -->
      </el-descriptions-item>
    </el-descriptions>
    <div class="mt-20 ta-c">
      <!-- <el-button size="small" type="primary" v-if="taskInfo.taskStatus !== 30 && taskInfo.taskStatus !== 50" @click="restartMission">重启任务</el-button> -->
      <el-button size="small" @click="readMission">已知晓</el-button>
    </div>
    <div class="ta-c mt-5" style="color:#F13736">
      <i class="el-icon-warning"></i><span>（请基于错误原因作出修改后，再重启任务）</span>
    </div>
    <el-dialog :visible.sync="photoState" title="任务流程展示" width="1330px" custom-class="process-display-dialog" top="9vh" append-to-body>
      <div>
        <div class="pd-lr15" v-if="photoList.length">
          <p class="fs-16 pd-lr15 mb-10">截图数据</p>
          <div class="flex" style="align-content: space-between;flex-wrap: wrap;">
            <div v-for="(item,index) in photoList" :key="index" class="ta-c d-ib ml-15 mb-10">
              <el-image style="width:300px;height: 200px" ref="previewImage" :src="item.fileUrl" :preview-src-list="imageUrlList"></el-image>
              <p>{{item.fileName}}</p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  Req_GetTaskInfo,
  Req_RestartTaxTask
} from '@/request/reptile'
import { Req_ReadMsg } from '@/request/user'
import {deepClone} from '@/util'
export default {
  props: {
    taskId: {
      type: String,
      required: true
    },
    msgId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      taskInfo: {},
      missionStatusMap: {
        30: '任务成功',
        // 20: '进行中',
        40: '任务失败',
        50: '已完成流程，无返回结果',
        60: '业务类型错误',
        41: '作废'
      },
      taskTypeMap: {
        10: '增值税报税',
        20: '财务报表报送',
        30: '发票获取',

      },
      imageUrlList: [],
      photoState: false,
      photoList: []
    }
  },
  created() {
    this.getMissionInfo()
  },
  methods: {
    getMissionInfo() {
      Req_GetTaskInfo(this.taskId).then(res => {
        this.taskInfo = res
        console.log(res.taskStatus)
      }).catch(err => this.$catchErr(err))
    },
    restartMission(){
      Req_RestartTaxTask({
        keyIds: [this.taskInfo.taskId],
        type:10
      }).then(res => {
        this.$message.success('成功重启任务')
      }).catch(err => this.$catchErr(err))
    },
    readMission(){
      return Req_ReadMsg({
        msgId: this.msgId
      }).then(() => {
        this.$emit('close')
      }).catch(err => this.$catchErr(err))
    },
    openPhotoState(){
      if(this.taskInfo.fileList) {
        const list = []
        this.taskInfo.fileList.forEach(item => {
          const arr = item.split('/')[item.split('/').length -1].split('.')
          const name = arr[0] + (arr[1].includes('_') ? arr[1].substr(arr[1].indexOf('_') + 1) : '')
          const param = {
            fileUrl: item,
            fileName: name
          }
          list.push(param)
        })
        this.photoList = list
        this.imageUrlList = this.photoList.map(item => item.fileUrl)
      }else{
        this.photoList = []
        this.imageUrlList = []
      }
      this.photoState = true
    },
  },
  watch: {
    taskId() {
      this.getMissionInfo()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AccAutomatic/MissionPublish.vue